import { Component, EventEmitter, Inject, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  PRODUCT_BIN_CONTEXT_MENU_PARAMS,
  ProductBinContextMenuParams
} from '../../services/contextmenu.service';
import { CapabilitiesService } from 'src/app/services/capabilities.service';
import { CapabilityType } from 'src/app/models/capability-type';

@Component({
  selector: 'app-product-bin-context-menu',
  templateUrl: './product-bin-context-menu.component.html',
  styleUrl: './product-bin-context-menu.component.scss',
  standalone: true,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
})
export class ProductBinContextMenuComponent {
  @Output() removeSingle = new EventEmitter<string>();
  @Output() removeFiltered = new EventEmitter<string>();

  constructor(
    @Inject(PRODUCT_BIN_CONTEXT_MENU_PARAMS) public params: ProductBinContextMenuParams,
    private capabilitiesService: CapabilitiesService
  ) {}

  get position() {
    return this.params.position;
  }

  get canEdit(): boolean {
    return this.capabilitiesService.hasCapability(CapabilityType.EDIT_PLANOGRAM);
  }
}
